const checkoutIdMappingMiddleware = ({ payload, next }) => {
    if (!payload || !payload.obj || !payload.obj.event) {
        next(payload);
        return;
    }

    payload.obj.properties = payload.obj.properties || {};

    const obj = payload.obj;

    if (obj.event != 'Order Completed') {
        next(payload);
        return;
    }

    try {
        const checkoutId = obj.properties.checkout_id;
        if (checkoutId) {
            obj.messageId = checkoutId;
        }
        delete obj.properties.order_id;
    } catch (e) {
        console.log(e);
    } finally {
        next(payload);
    }
};

const getMiddlewareDefinitions = () => {
    return [{ targetIntegration: 'Facebook Pixel', middlewares: [checkoutIdMappingMiddleware] }];
};

module.exports = {
    getDestinationMiddlewares: getMiddlewareDefinitions
};
